"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderStyleDirection = exports.renderClassNameForRow = exports.checkForExternalLink = void 0;
var _ButtonAndCTAMethods = require("../../utils/methods/ButtonAndCTAMethods");
const renderClassNameForRow = (direction, className) => {
  const formmatedClassName = className ? (0, _ButtonAndCTAMethods.formatClassName)(className) : null;
  if (direction === "row" && formmatedClassName) {
    return `${formmatedClassName} ter-button-row`;
  } else if (direction === "row" && !formmatedClassName) {
    return "ter-button-row ter-button--secondary--1";
  } else {
    return formmatedClassName || "ter-button--secondary--1";
  }
};
exports.renderClassNameForRow = renderClassNameForRow;
const renderStyleDirection = direction => {
  if (direction === "column") {
    return "column";
  } else if (direction === "row") {
    return "row";
  } else {
    return "column";
  }
};
exports.renderStyleDirection = renderStyleDirection;
const checkForExternalLink = url => {
  if (url && url.length >= 4 && url.substring(0, 4) === "http") {
    return true;
  } else {
    return false;
  }
};
exports.checkForExternalLink = checkForExternalLink;